import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8.25 8.7a.55.55 0 1 0 0 1.1.55.55 0 0 0 0-1.1Zm-1.95.55a1.95 1.95 0 1 1 3.9 0 1.95 1.95 0 0 1-3.9 0Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 4.7a.7.7 0 0 1 .7-.7h16.6a.7.7 0 0 1 .7.7v14.6a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V4.7Zm1.4.7v9.834a9.975 9.975 0 0 1 1.806-1.141c1.322-.662 2.899-1.15 4.56-1.41 2.902-.453 6.159-.222 8.834 1.109V5.4H4.4Zm15.2 9.986c-2.426-1.455-5.653-1.782-8.617-1.32-1.538.24-2.974.69-4.151 1.279-1.098.549-1.93 1.198-2.432 1.875v1.38h15.2v-3.214Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
